import { defineMessages } from 'react-intl';

export default defineMessages({
  withLogistics: {
    id: 'app.modules.DeliveryTypeInfo.withLogistics',
    defaultMessage: 'Entrega de PedidosYa',
  },
  ownDelivery: {
    id: 'app.modules.DeliveryTypeInfo.ownDelivery',
    defaultMessage: 'Entrega del local',
  },
  close: {
    id: 'app.modules.DeliveryTypeInfo.close',
    defaultMessage: 'Cerrar',
  },
});
